/**
 * Labstep
 *
 * @module components/Organization/GroupManager
 * @desc Organization Group Manager
 */

import EntitySearch from 'labstep-web/components/Entity/Search';
import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { DefaultSort } from 'labstep-web/components/Entity/Table/SortOptions/utils';
import GroupActionCreate from 'labstep-web/components/Group/Action/Create';
import { GroupEmptyState } from 'labstep-web/components/Group/EmptyState';
import GroupTable from 'labstep-web/components/Group/Table';
import { Filter } from 'labstep-web/constants/filters';
import { withUiPersistent } from 'labstep-web/containers/UiPersistent';
import { Group } from 'labstep-web/models/group.model';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { OrganizationGroupManagerManagerProps } from './types';

export const OrganizationGroupManager: React.FC<
  OrganizationGroupManagerManagerProps
> = ({ organization, uiPersistent, location }) => (
  <EntitySearch
    entityName={Group.entityName}
    params={{ organization_id: organization.id }}
    filters={[Filter.deleted]}
    action={() => <GroupActionCreate />}
    noResultsMessage={<GroupEmptyState />}
    sortOptions={{
      name: {
        label: 'Name',
        default_sort: DefaultSort.asc,
      },
    }}
    historyAction="replace"
    initialSearchParams={
      uiPersistent.search_params[location.pathname] as any
    }
    bulkActions={[BulkAction.delete]}
  >
    {({ entities }) => <GroupTable groups={entities} />}
  </EntitySearch>
);

export default withRouter(withUiPersistent(OrganizationGroupManager));
